import React, { useEffect } from 'react'
import { ActivityIndicator, ScrollView } from 'react-native'

import OtaStrip from '@zet/common/components/otaStrip'
import { useFreshchat } from '@zet/common/hooks/useFreshchat'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Stack } from '@zet/design-system/layout'
import { useAppComms } from '@zet/feature-user/api/appComms/hooks'
import _ from 'lodash'

import {
  useMyTeamsEarningsTotal,
  useShowPayoutEarnings,
} from '../../api/earnings/hooks'
import { useGetCustomerCount } from '../../api/homeScreenBridge/hooks'
import FloatingButton from '../../components/homeScreen/FloatingButton'
import EarningWidgetContainer from '../../components/homeScreen/earningsWidget'
import EmptyLead from '../../components/homeScreen/emptyLead'
import FooterBridge from '../../components/homeScreen/footer'
import LeadsSummary from '../../components/homeScreen/leadsSummary'
import MyCustomers from '../../components/homeScreen/myCustomers'
import TopBrands from '../../components/homeScreen/topBrands'
import useStore from '../../store'

const HomeScreen = () => {
  const { refetch } = useAppComms()
  const { data, isLoading } = useGetCustomerCount()
  const { data: showPayout } = useShowPayoutEarnings()
  const { navigate } = useNavigation()
  const { updateFreshchatUser } = useFreshchat()
  const { user } = useStore()
  const { data: totalEarnings } = useMyTeamsEarningsTotal()
  useEffect(() => {
    refetch()
  }, [])

  useEffect(() => {
    if (!_.isEmpty(user)) updateFreshchatUser(user)
  }, [user, updateFreshchatUser])
  return (
    <Stack className=" bg-neutral-white100 flex-1">
      <ScrollView>
        {isLoading ? (
          <ActivityIndicator />
        ) : (
          <>
            {showPayout && <EarningWidgetContainer />}
            {data?.data?.totalCount === 0 ? (
              <EmptyLead />
            ) : (
              <>
                <LeadsSummary />
                <MyCustomers
                  verified={data?.data?.verified}
                  nonVerified={data?.data?.notVerified}
                  customerAddedLastSevenDays={
                    data?.data?.customersAddedLastSevenDays
                  }
                  totalCount={data?.data?.totalCount}
                />
              </>
            )}
            <TopBrands />
          </>
        )}
      </ScrollView>
      <FooterBridge position="left" />
      <FloatingButton />
      {!__DEV__ && <OtaStrip />}
    </Stack>
  )
}

export default HomeScreen
